import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Container } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import withContent from '../../../containers/withContent';
import ManagePaymentContent, {
	contentPropTypes as ManagePaymentContentPropTypes,
} from '../../content/ManagePayment.content';
import DifferenceModalContent, { contentPropTypes as DifferenceModalContentPropTypes } from './DifferenceModal.content';

export const DifferenceModal = ({
	content: { mandateDifferenceHeader, directDebitsDefinition, DDSOInformation, standingOrderDefinition, buttonOk },
	closeModal,
}) => (
	<Modal size="lg" isOpen onRequestClose={closeModal} onClose={closeModal}>
		<Container className="modal__container u-padding-y-4">
			<h2>{mandateDifferenceHeader}</h2>
			<div className="u-margin-bottom-2">
				<p>{directDebitsDefinition}</p>
				<p>{standingOrderDefinition}</p>
				<p>{DDSOInformation}</p>
				<Button id="difference-modal-ok-button" onClick={closeModal} width="flush" display="primary">
					{buttonOk}
				</Button>
			</div>
		</Container>
	</Modal>
);

DifferenceModal.propTypes = {
	content: PropTypes.shape({
		...ManagePaymentContentPropTypes,
		...DifferenceModalContentPropTypes,
	}),
	closeModal: PropTypes.func.isRequired,
};
export default compose(withContent({ content: { ...ManagePaymentContent, ...DifferenceModalContent } }))(
	DifferenceModal
);
